import MapModal from "@/views/Auth/Presence/component/MapModal"
import { mapActions } from "vuex";

export default {
  data: () => ({
    employeeId: "",
    password: "",
    requestNext: {},
    tabAttendance: 1,
    lat: "",
    lng: "",
    modal: {
      map: false
    }
  }),
  computed: {},
  components: {
    MapModal
  },
  methods: {
    ...mapActions("attendance", ["enterPresence", "leavePresence", "getLocationOffices"]),
    getLocation() {
      this.$getLocation({
        enableHighAccuracy: true
      })
        .then(coordinates => {
          this.lat = coordinates.lat;
          this.lng = coordinates.lng;
        });
    },
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type
      });
    },
    toggleModal() {
      try {
        if (this.employeeId === "") throw "ID karyawan belum diisi";
        if (this.password === "") throw "Kata sandi belum diisi";
        this.modal.map = !this.modal.map;
        this.requestNext = {
          employeeId: this.employeeId,
          password: this.password,
          tabAttendance: this.tabAttendance
        };
      } catch (err) {
        this.notifyVue("danger", err);
      }
    },
    async submitAttendaceONE() {
      try {
        if (!this.lat && !this.lng) throw "The location access not allowed, refresh and allow location acccess"
        this.getLocation();
        const request = {
          employeeId: this.employeeId,
          password: this.password,
          latitude: this.lat,
          longitude: this.lng
        };
        if (this.tabAttendance === 1) {
          await this.enterPresence(request);
          this.notifyVue("success", "Enter presence is success");
        } else {
          await this.leavePresence(request);
          this.notifyVue("success", "Leave presence is success");
        }
        this.$router.push("/auth/login");
      } catch (err) {
        if (err?.response?.status === 401) {
          this.notifyVue("danger", err.response.data.error);
        } else if (err?.response?.status === 400) {
          this.notifyVue("danger", err.response.data.error);
        } else {
          this.notifyVue("danger", err);
        }
      }
    },

  },
  created() {
    this.getLocationOffices();
  }
};
